import type {
  StripeCardCvcElementOptions,
  StripeCardExpiryElementOptions,
  StripeCardNumberElementOptions,
} from '@stripe/stripe-js';

export const CREDIT_CARD_ELEMENT_OPTIONS:
  | StripeCardCvcElementOptions
  | StripeCardExpiryElementOptions
  | StripeCardNumberElementOptions = {
  style: {
    base: {
      padding: '16px 16px',
      color: '#595959',
      fontFamily:
        'SeekSans, "Helvetica Neue", HelveticaNeue, Helvetica, Arial, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#595959',
    },
  },
};
